import { GridColDef } from "@mui/x-data-grid";
import { Button, Box, Typography, Tooltip } from "@mui/material";

interface QuizColumnProps {
  assets: any[];
  activeTab: number;
  navigate: (path: string) => void;
}

// Common component for the "+N" indicator
const CountBadge = ({
  count,
  items,
  displayProperty,
}: {
  count: number;
  items: any[];
  displayProperty: string;
}) => {
  if (count <= 0) return null;
  const tooltipContent = (
    <Box sx={{ p: 1, maxHeight: 190, overflowY: "auto" }}>
      {items.slice(1).map((items, index) => (
        <Typography key={index} variant="body2">
          {items[displayProperty]}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} placement="top">
      <Box
        sx={{
          height: "20px",
          minWidth: "20px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "0px 2px",
          fontSize: "12px",
          color: "#666",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        +{count}
      </Box>
    </Tooltip>
  );
};

export const quizColumns = ({
  assets,
  activeTab,
  navigate,
}: QuizColumnProps): GridColDef[] => {
  const currentAssests = assets[activeTab];
  return [
    {
      field: "assetName",
      headerName: "Asset Name",
      flex: 1,
      renderCell: (params) => {
        return (
          <Button
            color="primary"
            sx={{
              textTransform: "none",
            }}
            onClick={() => navigate(`asset/${params.row.code}/versions`)}
          >
            {params.row.name}
          </Button>
        );
      },
    },
    {
      field: "programName",
      headerName: "Program Name",
      flex: 1,
      renderCell: (params) => {
        const usages = params.row.usages;
        const firstProgramName = usages?.[0]?.programName;
        const additionalProgramsCount =
          usages.length > 1 ? usages.length - 1 : 0;
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box>{firstProgramName}</Box>
            <CountBadge
              count={additionalProgramsCount}
              items={usages}
              displayProperty="programName"
            />
          </Box>
        );
      },
    },
    {
      field: "cohortId",
      headerName: "Cohort ID",
      flex: 1,
      renderCell: (params) => {
        const cohortId = params.row.workshopDetails;
        const firstCohortId = cohortId?.[0]?.code;
        const additionalCohortsCount =
          cohortId.length > 1 ? cohortId.length - 1 : 0;
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box>{firstCohortId}</Box>
            <CountBadge
              count={additionalCohortsCount}
              items={cohortId}
              displayProperty="code"
            />
          </Box>
        );
      },
    },
  ];
};
